module.exports = __webpack_public_path__ + "static/media/Sheriff.0a7b3594.jpg";